import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Brake from '../views/Brake.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home'),
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司'
    }
  },

  {
    path: '/brake',
    name: 'Brake',
    component: () => import('@/views/Brake'),
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司',
      desc : '跳转'
    } ,
  },
  {
    path: '/brake/disc',
    name : 'BrakeDisc' ,
    component: () => import('@/views/brakePages/Disc'),
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司'
    } ,
  },
  // {
  //   path: '/brake/disc/SD',
  //   name : 'BrakeDiscSD' ,
  //   component: () => import('@/views/brakePages/discComponents/SD'),
  //   meta: {
  //     title: 'DIXCEL中国'
  //   } ,
  // },
  // {
  //   path: '/brake/pad/ES',
  //   name : 'BrakePadES' ,
  //   component: () => import('@/views/brakePages/padComponents/ES'),
  //   meta: {
  //     title: 'DIXCEL中国'
  //   } ,
  // },
  // {
  //   path: '/brake/fluid/328',
  //   name : 'BrakeFluid328' ,
  //   component: () => import('@/views/brakePages/fluidComponents/328'),
  //   meta: {
  //     title: 'DIXCEL中国'
  //   } ,
  // },

  {
    path: '/brand',
    name: 'Brand',
    component: () => import('@/views/Brand'),
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司' ,
      desc : '跳转'
    } ,
  },
  {
    path: '/brand/brandHistory',
    name : 'BrandHistory' ,
    component: () => import('@/views/brandPages/BrandHistory'),
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司'
    } ,
  },
  {
    path: '/brand/dixcelJp',
    name : 'DixcelJp' ,
    component: () => import('@/views/brandPages/DixcelJp'),
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司'
    } ,
  },
  {
    path: '/brand/dixcelCn',
    name : 'DixcelCn' ,
    component: () => import('@/views/brandPages/DixcelCn'),
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司'
    } ,
  },
  {
    path: '/brand/DJHoldings',
    name : 'DJHoldings' ,
    component: () => import('@/views/brandPages/DJHoldings'),
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司'
    } ,
  },
  //制动课堂
  {
    path: '/brakeClassroom',
    name: 'BrakeClassroom',
    component: () => import('@/views/BrakeClassroom'),
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司' ,
      desc : '跳转'
    } ,
  },
  {
    path: '/brakeClassroom/brakepads' ,  //课堂 刹车片
    name: 'BrakepadsClassroom',
    component: () => import('@/views/brandClassroomPages/BrakepadsClassroom'),
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司'
    } ,
  },
  {
    path: '/brakeClassroom/brakepads/' ,
    name: 'BrakepadsClassroomPage',
    component: () => import('@/views/brandClassroomPages/BrakepadsClassroomPage/brakepads'),
    children: [
      {
        path: 'BrakepadsClassroom1',
        component: () => import('@/views/brandClassroomPages/BrakepadsClassroomPage/BrakepadsClassroom1'),
      },
      {
        path: 'BrakepadsClassroom2',
        component: () => import('@/views/brandClassroomPages/BrakepadsClassroomPage/BrakepadsClassroom2'),
      },
      {
        path: 'BrakepadsClassroom3',
        component: () => import('@/views/brandClassroomPages/BrakepadsClassroomPage/BrakepadsClassroom3'),
      },
      {
        path: 'BrakepadsClassroom4',
        component: () => import('@/views/brandClassroomPages/BrakepadsClassroomPage/BrakepadsClassroom4'),
      },
      {
        path: 'BrakepadsClassroom5',
        component: () => import('@/views/brandClassroomPages/BrakepadsClassroomPage/BrakepadsClassroom5'),
      },
      {
        path: 'BrakepadsClassroom6',
        component: () => import('@/views/brandClassroomPages/BrakepadsClassroomPage/BrakepadsClassroom6'),
      },
      {
        path: 'BrakepadsClassroom7',
        component: () => import('@/views/brandClassroomPages/BrakepadsClassroomPage/BrakepadsClassroom7'),
      },
      {
        path: 'BrakepadsClassroom8',
        component: () => import('@/views/brandClassroomPages/BrakepadsClassroomPage/BrakepadsClassroom8'),
      },
    ],
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司'
    } ,
  },

  {
    path: '/brakeClassroom/brakedisc' ,  //课堂 刹车盘
    name: 'BrakediscClassroom',
    component: () => import('@/views/brandClassroomPages/BrakediscClassroom'),
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司'
    } ,
  },
  {
    path: '/brakeClassroom/brakedisc/' ,
    name: 'BrakediscClassroomPage',
    component: () => import('@/views/brandClassroomPages/BrakediscClassroomPage/brakedisc'),
    children: [
      {
        path: 'BrakediscClassroom1',
        component: () => import('@/views/brandClassroomPages/BrakediscClassroomPage/BrakediscClassroom1'),
      },
      {
        path: 'BrakediscClassroom2',
        component: () => import('@/views/brandClassroomPages/BrakediscClassroomPage/BrakediscClassroom2'),
      },
      {
        path: 'BrakediscClassroom3',
        component: () => import('@/views/brandClassroomPages/BrakediscClassroomPage/BrakediscClassroom3'),
      },
      {
        path: 'BrakediscClassroom4',
        component: () => import('@/views/brandClassroomPages/BrakediscClassroomPage/BrakediscClassroom4'),
      },
      {
        path: 'BrakediscClassroom5',
        component: () => import('@/views/brandClassroomPages/BrakediscClassroomPage/BrakediscClassroom5'),
      },
      {
        path: 'BrakediscClassroom6',
        component: () => import('@/views/brandClassroomPages/BrakediscClassroomPage/BrakediscClassroom6'),
      },
      {
        path: 'BrakediscClassroom7',
        component: () => import('@/views/brandClassroomPages/BrakediscClassroomPage/BrakediscClassroom7'),
      },
      {
        path: 'BrakediscClassroom8',
        component: () => import('@/views/brandClassroomPages/BrakediscClassroomPage/BrakediscClassroom8'),
      },
      {
        path: 'BrakediscClassroom9',
        component: () => import('@/views/brandClassroomPages/BrakediscClassroomPage/BrakediscClassroom9'),
      },
    ],
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司'
    } ,
  },

  {
    path: '/brakeClassroom/brakeoil' ,  //课堂 刹车盘
    name: 'BrakeoilClassroom',
    component: () => import('@/views/brandClassroomPages/BrakeoilClassroom'),
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司'
    } ,
  },
  {
    path: '/brakeClassroom/brakeoil/' ,
    name: 'BrakeoilClassroomPage',
    component: () => import('@/views/brandClassroomPages/BrakeoilClassroomPage/brakeoil'),
    children: [
      {
        path: 'BrakeoilClassroom1',
        component: () => import('@/views/brandClassroomPages/BrakeoilClassroomPage/BrakeoilClassroom1'),
      },
      {
        path: 'BrakeoilClassroom2',
        component: () => import('@/views/brandClassroomPages/BrakeoilClassroomPage/BrakeoilClassroom2'),
      },
      {
        path: 'BrakeoilClassroom3',
        component: () => import('@/views/brandClassroomPages/BrakeoilClassroomPage/BrakeoilClassroom3'),
      },
      {
        path: 'BrakeoilClassroom4',
        component: () => import('@/views/brandClassroomPages/BrakeoilClassroomPage/BrakeoilClassroom4'),
      },
      {
        path: 'BrakeoilClassroom5',
        component: () => import('@/views/brandClassroomPages/BrakeoilClassroomPage/BrakeoilClassroom5'),
      },
      {
        path: 'BrakeoilClassroom6',
        component: () => import('@/views/brandClassroomPages/BrakeoilClassroomPage/BrakeoilClassroom6'),
      },
      {
        path: 'BrakeoilClassroom7',
        component: () => import('@/views/brandClassroomPages/BrakeoilClassroomPage/BrakeoilClassroom7'),
      },
    ],
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司'
    } ,
  },
  {
    path: '/brakeClassroom/other' ,  //课堂 其他
    name: 'OtherClassroom',
    component: () => import('@/views/brandClassroomPages/OtherClassroom'),
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司'
    } ,
  },
  {
    path: '/brakeClassroom/other/' ,  //课堂 其他
    name: 'OtherClassroomPage',
    component: () => import('@/views/brandClassroomPages/OtherClassroomPage/other'),
    children : [
      {
        path: 'OtherClassroom1',
        component: () => import('@/views/brandClassroomPages/OtherClassroomPage/OtherClassroom1'),
      },
      {
        path: 'OtherClassroom2',
        component: () => import('@/views/brandClassroomPages/OtherClassroomPage/OtherClassroom2'),
      },
      {
        path: 'OtherClassroom3',
        component: () => import('@/views/brandClassroomPages/OtherClassroomPage/OtherClassroom3'),
      },
      {
        path: 'OtherClassroom4',
        component: () => import('@/views/brandClassroomPages/OtherClassroomPage/OtherClassroom4'),
      },
      {
        path: 'OtherClassroom5',
        component: () => import('@/views/brandClassroomPages/OtherClassroomPage/OtherClassroom5'),
      },
      {
        path: 'OtherClassroom6',
        component: () => import('@/views/brandClassroomPages/OtherClassroomPage/OtherClassroom6'),
      },
      {
        path: 'OtherClassroom7',
        component: () => import('@/views/brandClassroomPages/OtherClassroomPage/OtherClassroom7'),
      },
      {
        path: 'OtherClassroom8',
        component: () => import('@/views/brandClassroomPages/OtherClassroomPage/OtherClassroom8'),
      },
      {
        path: 'OtherClassroom9',
        component: () => import('@/views/brandClassroomPages/OtherClassroomPage/OtherClassroom9'),
      },
      {
        path: 'OtherClassroom10',
        component: () => import('@/views/brandClassroomPages/OtherClassroomPage/OtherClassroom10'),
      },
    ],
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司'
    } ,
  },

  //网上商城
  {
    path: '/shopMallOnline',
    name: 'ShopMallOnline',
    component: () => import('@/views/ShopMallOnline'),
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司',
      desc : '跳转'
    } ,
  } ,
  //网上商城
  {
    path: '/dealer/home',
    name: 'DealerHome',
    component: () => import('@/views/dealer/home'),
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司',
      desc : '跳转'
    } ,
  } ,
  {
    path: '/variousproducts/other' ,
    name : 'Other' ,
    component: () => import('@/views/variousproducts/Other'),
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司'
    } ,
  },
  {
    path: '/variousproducts/other/:id' ,
    name : 'Other' ,
    component: () => import('@/views/variousproducts/OtherDetail'),
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司'
    } ,
  },
  {
    path: '/variousproducts/brakeOil' ,
    component: () => import('@/views/variousproducts/BrakeOil'),
    meta: {
      title: 'DIXCEL中国'
    } ,
  },
  {  //刹车油详情
    path: '/variousproducts/brakeOil/:id' ,
    component: () => import('@/views/variousproducts/BrakeOilDetail'),
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司'
    } ,
  },

  {
    path: '/variousproducts/brakePads' ,
    component: () => import('@/views/variousproducts/BrakePads'),
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司'
    } ,
  },
  {
    path: '/variousproducts/brakePads/:id' ,
    component: () => import('@/views/variousproducts/BrakePadsDetail'),
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司'
    } ,
  },

  {
    path: '/variousproducts/brakedisc' ,
    component: () => import('@/views/variousproducts/Brakedisc'),
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司'
    } ,
  },
  {
    path: '/variousproducts/brakedisc/:id' ,
    component: () => import('@/views/variousproducts/BrakediscDetail'),
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司'
    } ,
  },
  {
    path: '/variousproducts/brakecalipers' ,
    component: () => import('@/views/variousproducts/Brakecalipers'),
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司'
    } ,
  },


  //精彩瞬间
  {
    path: '/moment' ,
    name : 'Moment' ,
    component: () => import('@/views/Moment'),
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司' ,
      desc : '跳转' ,
    } ,
  },
  {
    path: '/moment/wonderfulVideo' ,
    name: 'WonderfulVideo',
    component: () => import('@/views/moment/WonderfulVideo'),
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司'
    } ,
  },
  {
    path: '/moment/image' ,
    name: 'Momentimage',

    component: () => import('@/views/moment/Image'),
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司'
    } ,
  },
  {
    path: '/moment/image/' ,
    name: 'MomentimagePage',
    component: () => import('@/views/moment/MomentimagePage/images'),
    children : [
      {
        path: 'images1',
        component: () => import('@/views/moment/MomentimagePage/images1'),
      },
      {
        path: 'images2',
        component: () => import('@/views/moment/MomentimagePage/images2'),
      },
      {
        path: 'images3',
        component: () => import('@/views/moment/MomentimagePage/images3'),
      },
      {
        path: 'images4',
        component: () => import('@/views/moment/MomentimagePage/images4'),
      },
      {
        path: 'images5',
        component: () => import('@/views/moment/MomentimagePage/images5'),
      },
      {
        path: 'images6',
        component: () => import('@/views/moment/MomentimagePage/images6'),
      },
      {
        path: 'images7',
        component: () => import('@/views/moment/MomentimagePage/images7'),
      },
      {
        path: 'images8',
        component: () => import('@/views/moment/MomentimagePage/images8'),
      },
      {
        path: 'images9',
        component: () => import('@/views/moment/MomentimagePage/images9'),
      },
      {
        path: 'images10',
        component: () => import('@/views/moment/MomentimagePage/images10'),
      },
      {
        path: 'images11',
        component: () => import('@/views/moment/MomentimagePage/images11'),
      },
    ],
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司'
    } ,
  },

  {
    path: '/moment/newsActivities' ,
    name: 'NewsActivities',
    component: () => import('@/views/moment/NewsActivities'),
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司'
    } ,
  },
  {
    path: '/moment/newsActivities/' ,
    name: 'NewsActivitiesNews',
    component: () => import('@/views/moment/NewsActivitiesPage/news'),
    children: [
      {
        path: '2013-04-07',
        component: () => import('@/views/moment/NewsActivitiesPage/2013_04_07'),
      },
      {
        path: '2013-04-25',
        component: () => import('@/views/moment/NewsActivitiesPage/2013_04_25'),
      },
      {
        path: '2013-05-17',
        component: () => import('@/views/moment/NewsActivitiesPage/2013_05_17'),
      },
      {
        path: '2013-05-09',
        component: () => import('@/views/moment/NewsActivitiesPage/2013_05_09'),
      },
      {
        path: '2013-09-11',
        component: () => import('@/views/moment/NewsActivitiesPage/2013_09_11'),
      },
      {
        path: '2013-05-16',
        component: () => import('@/views/moment/NewsActivitiesPage/2013_05_16'),
      },
      {
        path: '2013-06-17',
        component: () => import('@/views/moment/NewsActivitiesPage/2013_06_17'),
      },
      {
        path: '2013-07-19' ,
        component: () => import('@/views/moment/NewsActivitiesPage/2013_07_19'),
      },
      {
        path: '2017-03-28' ,
        component: () => import('@/views/moment/NewsActivitiesPage/2017_03_28'),
      },
      {
        path: '2016-03-30' ,
        component: () => import('@/views/moment/NewsActivitiesPage/2016_03_30'),
      } ,
      {
        path: '2016-12-09' ,
        component: () => import('@/views/moment/NewsActivitiesPage/2016_12_09'),
      } ,
      {
        path: '2017-03-21' ,
        component: () => import('@/views/moment/NewsActivitiesPage/2017_03_21'),
      } ,
      {
        path: '2017-06-23' ,
        component: () => import('@/views/moment/NewsActivitiesPage/2017_06_23'),
      } ,
      {
        path: '2017-09-23' ,
        component: () => import('@/views/moment/NewsActivitiesPage/2017_09_23'),
      } ,
      {
        path : '2018-04-02' ,
        component: () => import('@/views/moment/NewsActivitiesPage/2018_04_02'),
      },
      {
        path : '2018-05-21' ,
        component: () => import('@/views/moment/NewsActivitiesPage/2018_05_21'),
      },
      {
        path : '2018-06-16' ,
        component: () => import('@/views/moment/NewsActivitiesPage/2018_06_16'),

      } ,
      {
        path : '2018-12-26' ,
        component: () => import('@/views/moment/NewsActivitiesPage/2018_12_26'),
      } ,
      {
        path : '2019-06-20' ,
        component: () => import('@/views/moment/NewsActivitiesPage/2019_06_20'),
      } ,
      {
        path : '2019-11-30' ,
        component: () => import('@/views/moment/NewsActivitiesPage/2019_11_30'),
      } ,
      {
        path : '2021-03-01' ,
        component: () => import('@/views/moment/NewsActivitiesPage/2021_03_01'),
      } ,
      {
        path : '2021-04-20' ,
        component: () => import('@/views/moment/NewsActivitiesPage/2021_04_20'),
      } ,{
        path : '2021-04-25' ,
        component: () => import('@/views/moment/NewsActivitiesPage/2021_04_25'),
      },{
        path : '2021-05-31' ,
        component: () => import('@/views/moment/NewsActivitiesPage/2021_05_31'),
      },{
        path : '2021-11-01' ,
        component: () => import('@/views/moment/NewsActivitiesPage/2021_11_01'),
      },{
        path : '2022-09-23' ,
        component: () => import('@/views/moment/NewsActivitiesPage/2022_09_23'),
      },{
        path : '2023-04-17' ,
        component: () => import('@/views/moment/NewsActivitiesPage/2023_04_17'),
      },{
        path : '2023-04-19' ,
        component: () => import('@/views/moment/NewsActivitiesPage/2023_04_19'),
      },{
        path : '2024-08-20' ,
        component: () => import('@/views/moment/NewsActivitiesPage/2024_08_20'),
      }
    ],
    meta: {
      title: 'DIXCEL官网-迪库盛贸易(上海)有限公司'
    } ,
  },

]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes ,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
        return savedPosition
    }
    return {x: 0, y: 0}
  }
})

router.beforeEach((to, from, next) => {//beforeEach是router的钩子函数，在进入路由前执行
  if (to.meta.title) {//判断是否有标题
    document.title = to.meta.title
  }
  if( to.meta.desc  == '跳转'  ){
    // var scrollTop =
    // window.pageYOffset ||
    // document.documentElement.scrollTop ||
    // document.body.scrollTop;
    window.scrollTo(0, 0);
  }
  next()
})
router.afterEach( () => {
  // var scrollTop =
  // window.pageYOffset ||
  // document.documentElement.scrollTop ||
  // document.body.scrollTop;
} )

export default router
